import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function AboutPage() {
  const [blocks, setBlocks] = useState([]);
  useEffect(() => { api.get("/about-blocks").then(setBlocks).catch(() => setBlocks([])); }, []);

  return (
    <div data-testid="about-page" className="relative">
      <section className="pt-20 pb-16 lg:pt-32 lg:pb-20 border-b border-border relative overflow-hidden">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-primary/15 blur-[140px]" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6 font-bold">Quiénes Somos</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-black tracking-tighter leading-[0.95] mb-10 max-w-5xl">
            La red nacional de <span className="gradient-text">influencia, contenido y producción</span>.
          </h1>
          <div className="grid lg:grid-cols-2 gap-10 max-w-5xl">
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed">
              INFLUCAST es una agencia nacional full-service de influencer marketing, producción local y creación de contenido para marcas que quieren conectar con audiencias reales. Nacimos para unir el poder de los talentos bolivianos con la estrategia, la producción y la medición que hoy exige el mercado digital.
            </p>
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed">
              No somos una agencia de menciones. Somos una red nacional de influencia, entretenimiento y producción. Diseñamos campañas, producimos contenidos, activamos talentos, desarrollamos transmisiones en vivo, impulsamos productos y creamos experiencias para marcas que buscan impacto, conversación y resultados.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-2 gap-px bg-border border border-border rounded-sm overflow-hidden">
            {blocks.map((b, i) => (
              <motion.div
                key={b.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="bg-background p-8 lg:p-12 hover:bg-secondary/30 transition-colors"
                data-testid={`about-block-${b.id}`}
              >
                <div className="text-6xl font-display font-black text-primary/20 mb-4">0{i + 1}</div>
                <h3 className="font-display font-bold text-2xl lg:text-3xl tracking-tight mb-4">{b.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{b.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
